import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';

import ChallengeQuestionPhoto from './ChallengeQuestionPhoto.js';

class ChallengeQuestionPhotoContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {highlight:false};
        this.onDrop = this.onDrop.bind(this);
        this.onDragOver = this.onDragOver.bind(this);
        this.onDragEnter = this.onDragEnter.bind(this);
        this.onDragLeave = this.onDragLeave.bind(this);
    }

    onDrop(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log('onDrop', e);


        var files = e.dataTransfer.files;
        var file = null;
        for (var i = 0, f; f = files[i]; i++) {
            // Read the File objects in this FileList.
            console.log('file=', f);
            file = f;
        }

        if(file) {
            this.props.onUploadPhoto({field:'selectedChallenge.challengeQuestions.' + this.props.index + '.data', width:512, height:512, file:file});
        }
        this.setState({highlight:false});
    }

    onDragOver(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log('onDragOver', e);
    }

    onDragEnter(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log('onDragEnter', e);
        this.setState({highlight:true});
    }

    onDragLeave(e) {
        e.stopPropagation();
        e.preventDefault();
        console.log('onDragLeave', e);
        this.setState({highlight:false});
    }

    render() {
        return <ChallengeQuestionPhoto {...this.state}
                                       {...this.props}
                                       onDragOver={this.onDragOver}
                                       onDragEnter={this.onDragEnter}
                                       onDragLeave={this.onDragLeave}
                                       onDrop={this.onDrop} />;
    }

}

export default withRouter(ChallengeQuestionPhotoContainer);



// WEBPACK FOOTER //
// ./src/modules/logs/ChallengeQuestionPhotoContainer.js